import * as React from "react";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
// import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { icon } from "@fortawesome/fontawesome-svg-core/import.macro";
import { useDispatch, useSelector } from "react-redux";
import { getCustomerStaffList, updatePreferredListProfile } from "../../../redux/reducers/authSlice";
import { toast } from "react-toastify";
import CircularProgress from '@mui/material/CircularProgress';
import { Badge } from "@mui/material";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

export default function EditModal({ isOpen, setIsOpen, title, myprofile }) {

  const { prefferdStaffList } = useSelector((state) => state.auth)
  const dispatch = useDispatch()
  const [localDummyArr, setLocalDummyArr] = React.useState([]);



  const handleClose = () => {
    setIsOpen(false);
  };


  const handleCheckboxChange = (e, staffUserId, isActive) => {

    setLocalDummyArr(prevStaffList =>
      prevStaffList.map(staff =>
        (staff.staffUserId === staffUserId && staff.isActive === "inactive" ) ? 
        { ...staff, isPreferredStaff: false } : 
        (staff.staffUserId === staffUserId && staff.isActive === "active" ? 
        { ...staff, isPreferredStaff: e.target.checked } : staff)
      )
    );

    if(isActive === "inactive" && e.target.checked === true){
      toast.error("This staff member is inactive, so you cannot select them.")
    }

  };

  function haveSameElements(arr1, arr2) {
    if (arr1.length !== arr2.length) return false;

    return arr1.every(item => arr2.includes(item));
  }

  const handleSubmit = () => {

    const storePrefferdStaffList = prefferdStaffList.filter(item => item.isPreferredStaff == true).map(item => item.staffUserId);
    const sortedArrayIds = localDummyArr.filter(item => item.isPreferredStaff === true)
      .map(item => item.staffUserId);

    if (sortedArrayIds.length <= 3) {

      if (haveSameElements(storePrefferdStaffList, sortedArrayIds)) {
        setIsOpen(false);
      } else {
        const data = sortedArrayIds.map(ids => ({ staff: ids }));
        const arrForApiData = { addStaffs: data }
        dispatch(updatePreferredListProfile({ values: arrForApiData, dispatch: dispatch }))
        setIsOpen(false);
      }

    } else {
      toast.error("You can only add up to 3 staff members.");
    }
  };
  React.useEffect(() => {
    dispatch(getCustomerStaffList())
  }, [])
  React.useEffect(() => {
    setLocalDummyArr(prefferdStaffList);
  }, [prefferdStaffList])
  return (
    <React.Fragment>
      <BootstrapDialog className="editmodal-wrap"
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={isOpen}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title" className="editmodal-heading">
          {title}
          <h4>You can select maximum upto 3 staff members</h4>
        </DialogTitle>

        <DialogContent className="edit-Modal-body" dividers> <div>
          <div className="row">
            {localDummyArr?.length > 0 ? localDummyArr?.map((staff, idx) => (
              <>
                <div className="col-lg-12 col-md-12">
                  <div className="form-group">
                    <div className="form-check d-flex align-items-center">

                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="terms-conditions"
                        name="terms"
                        checked={staff.isPreferredStaff}
                        onChange={(e) => handleCheckboxChange(e, staff.staffUserId, staff.isActive)}
                      />
                      <Badge
                        overlap="circular"
                        badgeContent=" "
                        sx={{
                          "& .MuiBadge-badge": {
                            width: "0.7rem",
                            height: "0.7rem",
                            borderRadius: "50%", 
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            minWidth: "unset",
                            padding: "1", 
                            lineHeight: "0.7rem", 
                            backgroundColor: `${staff.isActive == "active" ? "#00ED64" : "#708090"}`, 
                          },
                        }}
                      >
                        <div className="user-bg">
                          {/* <FontAwesomeIcon icon={icon({ name: "user" })} /> */}
                          <img src={staff?.profileimageurl ? staff?.profileimageurl : "/assets/images/staffAvatar.png"} />
                        </div>
                      </Badge>
                      
                      <label className="form-check-label" htmlFor="terms-conditions">
                        {staff.name}
                      </label>
                    </div>
                  </div>
                </div>
              </>
            )) : <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100px",
              }}
            >
              <CircularProgress
                style={{
                  width: "10vw",
                  maxWidth: "40px",
                  minWidth: "20px",
                }}
              />
            </div>}

          </div>
        </div></DialogContent>
        <DialogActions>
          <Button className="btn" autoFocus disabled={(localDummyArr?.length === 0) ? true : false} onClick={handleSubmit}>
            Save changes
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </React.Fragment>
  );
}
